// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'qr';

export const Component = () => (
  <path d='M3.36 8.188V3.36h4.828v4.828H3.36Zm-1.923-6.75h8.672v8.671H1.437V1.437Zm9.61 9.609V.5H.5v10.547h10.547ZM3.36 21.594v-4.781h4.828v4.781H3.36Zm-1.923-6.703h8.672v8.625H1.437V14.89Zm9.61 9.609V13.953H.5V24.5h10.547Zm5.765-16.312V3.36h4.828v4.828h-4.828Zm-.937 14.39v-6.702h6.703v6.702h-6.703Zm-.984-21.14h8.672v8.671H14.89V1.437Zm9.609 9.609V.5H13.953v10.547H24.5Z' />
);

export const viewBox = '0 0 25 25';
